import SEO from '../components/SEO';
import PriceCalculator from '../components/PriceCalculator';

export default function CalculatorPage() {
  return (
    <div className="bg-slate-50/50 py-10 sm:py-16">
      <SEO
        title="Prisberegner - Power-Multiservice"
        description="Beregn en vejledende pris på din rengøringsopgave og modtag et uforpligtende tilbud fra Power-Multiservice."
        path="/prisberegner"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Intro Header */}
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">
            Beregn din rengøringspris online
          </h1>
          <p className="mt-3 text-base sm:text-lg text-slate-600 leading-relaxed">
            Få en hurtig indikation af prisen på din rengøringsopgave for både private boliger og erhvervslokaler. Gennemfør de 5 enkle trin herunder og send din forespørgsel direkte for et endeligt, uforpligtende tilbud.
          </p>
        </div>

        {/* The Interactive Calculator */}
        <PriceCalculator embedded={true} />

        {/* Info & FAQ box */}
        <div className="w-full mt-12 sm:mt-16 bg-white border border-slate-200 p-6 sm:p-8 shadow-sm">
          <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2">
            <i className="fa-solid fa-circle-info text-black" aria-hidden="true" />
            <span>Værd at vide om prisberegningen</span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-slate-600 leading-relaxed">
            <div>
              <h4 className="font-bold text-slate-800 mb-1">Er prisen bindende?</h4>
              <p>
                Nej, beregneren giver et vejledende prisestimat. Når du sender dine oplysninger, kontakter vi dig hurtigt med et fast, uforpligtende tilbud tilpasset dine specifikke ønsker.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-slate-800 mb-1">Hvad med moms?</h4>
              <p>
                Priser for privat rengøring vises vejledende inkl. moms. Priser for erhvervsrengøring vises ekskl. moms i overensstemmelse med gældende regler.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-slate-800 mb-1">Er der binding på en aftale?</h4>
              <p>
                Nej, vi ønsker glade og tilfredse kunder og arbejder derfor med fleksible aftaler uden urimelige bindingsperioder.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-slate-800 mb-1">Har du særlige ønsker?</h4>
              <p>
                Du er altid velkommen til at ringe direkte til os på <a href="tel:31686764" className="text-blue-900 font-bold hover:underline whitespace-nowrap">31 68 67 64</a> for en uforpligtende dialog.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
